import type { ItemKind } from '../constants/vocabulary';

const id = (value: string): string => encodeURIComponent(value);

const LIBRARY = '/v2/equipment-library';

const typePath = (code: string): string => `${LIBRARY}/types/${id(code)}`;
const registryPath = (plantId: string): string => `/v2/plants/${id(plantId)}/equipment-registry`;
const entryPath = (plantId: string, entryId: string): string => `${registryPath(plantId)}/${id(entryId)}`;
const analysisPath = (plantId: string): string => `/v2/plants/${id(plantId)}/scada-analysis`;

export const CTL_CONFIG_ENDPOINTS = {
  TYPES: `${LIBRARY}/types`,
  TYPE: typePath,
  TYPE_HISTORY: (code: string): string => `${typePath(code)}/history`,
  READINGS: `${LIBRARY}/readings`,
  PLANT_TYPES: `${LIBRARY}/plant-types`,
  PLANTS: `${LIBRARY}/plants`,
  NODE_TYPES: `${LIBRARY}/node-types`,
  REGISTRY: registryPath,
  REGISTRY_ENTRY: entryPath,
  REGISTRY_TIER: (plantId: string, entryId: string): string => `${entryPath(plantId, entryId)}/tier`,
  REGISTRY_OVERRIDE: (plantId: string, entryId: string, kind: ItemKind, key: string): string =>
    `${entryPath(plantId, entryId)}/overrides/${id(kind)}/${id(key)}`,
  REGISTRY_MAINTENANCE: (plantId: string, entryId: string): string => `${entryPath(plantId, entryId)}/maintenance`,
  SCADA_ANALYSIS: analysisPath,
  SCADA_APPLY: (plantId: string): string => `${analysisPath(plantId)}/apply`,
} as const;
